var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m 33.41137,4.8203651 c 5.213897,0 9.411367,4.2770582 9.411367,9.5898179 v 19.179635 c 0,5.31276 -4.19747,9.589817 -9.411367,9.589817 H 14.588631 c -5.2138994,0 -9.4113684,-4.277057 -9.4113684,-9.589817 V 29.394273 H 18.937407 v 5.394273 L 33.803509,24.000001 18.937407,13.211456 v 5.394271 H 5.1772626 v -4.195544 c 0,-5.3127597 4.197469,-9.5898179 9.4113684,-9.5898179 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsng);
export default __webpack_public_path__ + "static/media/isng.fe1dd403559293ae480b5a8b0f5951e4.svg";
export { ForwardRef as ReactComponent };